import { ClientWorkOrderFolder } from "@redotech/redo-views-common/folders";
import { ClientWorkOrderView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";
export const getWorkOrderViewsAndFolders = {
  name: "getWorkOrderViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientWorkOrderFolder),
    views: z.array(ClientWorkOrderView),
  }),
};
